/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h4[_ngcontent-%COMP%]{text-align:left!important;text-transform:none!important;margin-top:10px!important;margin-bottom:10px!important;font-family:inherit!important;font-weight:500!important;line-height:1.1;color:inherit!important;padding:0!important}"];
export { styles as styles };
